import React from 'react';
import _ from 'lodash';
import Table from '../Table/Table';
import {
    transformDateTimeCell
} from '../../utils/cell';
import ExportsAvailableListItem from './ExportsAvailableListItem/ExportsAvailableListItem';
import { exportServiceUrl, getAvailableExports as fetchAvailableExports } from './exportsActions';
import {
    getCount,
    getPages,
    getExportsAvailableErrorMessage,
    getIsExportsAvailableLoading,
    getExportsAvailable,
    getExportEntityErrorMessage
} from './exportsEntity';
import moment from 'moment';
import {
    createReportName,
    determineStatus
} from './exportsUtil';
import './ExportsAvailableListItem/ExportsAvailableListItem.scss';
import Actions from './Actions/Actions';
import { connect } from 'react-redux';
import { toastIfError } from '../../utils/toast';

const defaultColumnsAndProps = [
    {
        accessor: 'reportName',
        label: 'Report Name',
        Cell: (props) => createReportName(_.get(props, 'original')),
        sortable: false,
        defaultSortDesc: true,
        filterable: false,
        minWidth: 150,
        show: true
    },
    {
        accessor: 'dateCreated',
        label: 'User Requested',
        Cell: transformDateTimeCell,
        minWidth: 150,
        sortable: false,
        filterable: false,
        show: true
    },
    {
        accessor: 'status',
        label: 'Status',
        Cell: (props) => determineStatus(props.original),
        filterable: false,
        minWidth: 150,
        show: true,
        sortable: false,
        value: 'hello world'
    },
    {
        accessor: 'expiration',
        label: 'Expiration',
        Cell: (props) => moment(props.original.dateCreated).add(7, 'days').format('MM/DD/YYYY'),
        minWidth: 150,
        filterable: false,
        show: true,
        sortable: false
    },
    {
        accessor: 'action',
        label: 'Action',
        Cell: (props) => <Actions record={props.original} />,
        filterable: false,
        minWidth: 150,
        show: true,
        sortable: false
    }
];

export class Exports extends React.Component {
    componentDidUpdate(previousProps) {
        toastIfError(previousProps, this.props, 'error');
    }

    render() {
        return (
            <Table
                fetchUrl={exportServiceUrl}
                className="emvio-exports-available-table"
                defaultColumnsAndProps={defaultColumnsAndProps}
                defaultPageSize={10}
                fetchData={fetchAvailableExports}
                dataSelector={getExportsAvailable}
                countSelector={getCount}
                errorMessageSelector={getExportsAvailableErrorMessage}
                isDataLoadingSelector={getIsExportsAvailableLoading}
                pagesSelector={getPages}
                shouldHideExport
                itemKey="guid"
                hasNoCount
                noDataText="No Available Exports Found"
                uniqueTableName="AvailableExports"
                ListItemComponent={ExportsAvailableListItem}
                filterable={false}
                /* eslint-disable-next-line @stylistic/max-len */
                footerText={<div>{'*If you\'ve requested an XSLX report containing 100,000 to 1 million rows, please take note of the extra sheet tabs located at the bottom of the opened report. Your downloaded report will organize the rows into sets of 100,000 per sheet.'}<br />{'**If you\'ve requested an XSLX report containing more than 1 million rows, there is a row limitation of over 1 million rows. As a result, your downloaded report will be in a CSV format instead.'}</div>}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        error: getExportEntityErrorMessage(state)
    };
}

export default connect(mapStateToProps)(Exports);
